import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { StateNodeConnection, StateNodeEdge } from '../../../schema';
import { stateDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class StateDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<StateNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { allStates: StateNodeConnection } }>(
        API_URL,
        { name },
        stateDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allStates.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<StateNodeEdge>, 'data'> {
  mode: 'single';
  value: StateNodeEdge;
  onChange: (value: StateNodeEdge) => void;
}
